import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class DtAddressService {
  private apiUrl = '/dtaddresses';

  constructor(private http: HttpService) { }

  get(ownerId?: number): Promise<any> {
    let url = '';
    if (ownerId !== undefined) {
      url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + '/spring'+ this.apiUrl}?ownerId=${ownerId}`;
    } else {
      url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + '/spring'+ this.apiUrl}`;
    }
    return this.http.get(url);
  }

  upload(file: File, ownerId: number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/excelupload/${ownerId}`;
    const formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name);
    const header = {
      'Accept': 'application/json',
      'x-api-key': localStorage.getItem('apiKey'),
      'x-session-key': (JSON.parse(sessionStorage.getItem('loginResult')))['sessionKey'],
      'x-csrf-token': (JSON.parse(sessionStorage.getItem('loginResult')))['csrfToken']
    };
    return this.http.post(url, formData, header);
  }

  post(
    ownerId: number,
    dtaddressCd: string,
    dtnameTx: string,
    dtpostalCd: string,
    dtaddress1Tx: string,
    dtaddress2Tx: string,
    dtaddress3Tx: string,
    dtdepartmentTx: string,
    dttelTx: string,
    carrierCd: string,
    delirouteId: number,
    delirouteCd: string,
    typeshipinvoiceCd: string,
    freeItem1Tx: string,
    freeItem2Tx: string,
    updprogramCd: string
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + '/spring' + this.apiUrl;
    const jsonInput = {
      ownerId: ownerId,
      dtaddressCd: dtaddressCd,
      dtnameTx: dtnameTx,
      dtpostalCd: dtpostalCd,
      dtaddress1Tx: dtaddress1Tx,
      dtaddress2Tx: dtaddress2Tx,
      dtaddress3Tx: dtaddress3Tx,
      dtdepartmentTx: dtdepartmentTx,
      dttelTx: dttelTx,
      carrierCd: carrierCd,
      delirouteId: delirouteId,
      delirouteCd: delirouteCd,
      typeshipinvoiceCd: typeshipinvoiceCd,
      freeItem1Tx: freeItem1Tx,
      freeItem2Tx: freeItem2Tx,
      updprogramCd: updprogramCd
    };

    return this.http.post(url, jsonInput);
  }

  put(
    ownerId: number,
    updcounterNr: number,
    dtaddressId: number,
    dtaddressCd: string,
    dtnameTx: string,
    dtpostalCd: string,
    dtaddress1Tx: string,
    dtaddress2Tx: string,
    dtaddress3Tx: string,
    dtdepartmentTx: string,
    dttelTx: string,
    carrierCd: string,
    delirouteId: number,
    delirouteCd: string,
    typeshipinvoiceCd: string,
    freeItem1Tx: string,
    freeItem2Tx: string,
    updprogramCd: string
  ): Promise<any> {
    const targetServiceCode = '';
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + '/spring' + this.apiUrl}/${dtaddressId}`;
    const jsonInput = {
      ownerId: ownerId,
      updcounterNr: updcounterNr,
      dtaddressCd: dtaddressCd,
      dtnameTx: dtnameTx,
      dtpostalCd: dtpostalCd,
      dtaddress1Tx: dtaddress1Tx,
      dtaddress2Tx: dtaddress2Tx,
      dtaddress3Tx: dtaddress3Tx,
      dtdepartmentTx: dtdepartmentTx,
      dttelTx: dttelTx,
      carrierCd: carrierCd,
      delirouteId: delirouteId,
      delirouteCd: delirouteCd,
      typeshipinvoiceCd: typeshipinvoiceCd,
      freeItem1Tx: freeItem1Tx,
      freeItem2Tx: freeItem2Tx,
      updprogramCd: updprogramCd
    };

    // SW-2055 : 本来、targetServiceCodeを引数としたくないが、届先修正APIがAAS版で動かないため、強制的に標準版として動作させたく、引数を追加する。
    return this.http.put(url, jsonInput, targetServiceCode);
  }

  delete(
    dtaddressId: number
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + '/spring' + this.apiUrl}/${dtaddressId}`;
    return this.http.delete(url);
  }

  dterror(
    shiphId: number,
    dtaddressId: number,
    dtaddressCd: string,
    dtnameTx: string,
    dtpostalCd: string,
    dtaddress1Tx: string,
    dtaddress2Tx: string,
    dtaddress3Tx: string,
    dttelTx: string,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + '/spring/dterror'}`;
    const jsonInput = {
      shiphId: shiphId,
      dtaddressId: dtaddressId,
      dtaddressCd: dtaddressCd,
      dtnameTx: dtnameTx,
      dtpostalCd: dtpostalCd,
      dtaddress1Tx: dtaddress1Tx,
      dtaddress2Tx: dtaddress2Tx,
      dtaddress3Tx: dtaddress3Tx,
      dttelTx: dttelTx,
      updprogramCd: updprogramCd
    };
    return this.http.put(url, jsonInput);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/dt-address/dt-address.service.ts